// Seeded RNG (mulberry32) — deterministic given seed; every draw threads new seed back.

export function nextRng(seed: number): [number, number] {
  let t = (seed + 0x6D2B79F5) | 0;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return [((t ^ (t >>> 14)) >>> 0) / 4294967296, t];
}

export function shuffle<T>(arr: T[], seed: number): [T[], number] {
  const a = [...arr];
  let s = seed;
  for (let i = a.length - 1; i > 0; i--) {
    let r: number;
    [r, s] = nextRng(s);
    const j = Math.floor(r * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return [a, s];
}

export function randInt(min: number, max: number, seed: number): [number, number] {
  let r: number;
  [r, seed] = nextRng(seed);
  return [min + Math.floor(r * (max - min + 1)), seed];
}
